/** In-memory ETag for project config + catalog; cleared on full page reload. */
const lastEffectiveUpdatedAtByProjectId: Record<string, string> = {}

export function getStoredProjectEffectiveUpdatedAt(projectId: string): string | undefined {
  return lastEffectiveUpdatedAtByProjectId[projectId]
}

export function setStoredProjectEffectiveUpdatedAt(
  projectId: string,
  effectiveUpdatedAt: string
): void {
  lastEffectiveUpdatedAtByProjectId[projectId] = effectiveUpdatedAt
}
